import React from 'react'
import PropTypes from 'prop-types'
import InfoChipStyled from './styled'

// Réplica de InfoChip del Storybook de Velora (hrbf_freezer/src/ui/components/InfoChip.tsx)
const InfoChip = ({ label, appearance, borderColor, fillColor, textColor, style, ...rest }) => (
  <InfoChipStyled
    {...rest}
    label={label}
    variant={appearance === 'border' ? 'outlined' : 'default'}
    $appearance={appearance}
    $borderColor={borderColor}
    $fillColor={fillColor}
    $textColor={textColor}
    style={style}
  />
)

InfoChip.propTypes = {
  label: PropTypes.node,
  appearance: PropTypes.oneOf(['filled', 'border']),
  borderColor: PropTypes.string,
  fillColor: PropTypes.string,
  textColor: PropTypes.string,
  style: PropTypes.object
}

InfoChip.defaultProps = {
  appearance: 'filled'
}

export default InfoChip
